/** The Sample At pickers have no seconds, so new samples never carry hidden ones. */
export const currentSampleMinute = (): Date => {
	const now = new Date();
	now.setSeconds(0, 0);
	return now;
};

/**
 * A new sample whose time the user never changed is saved at the moment of
 * saving, not when the form was opened. A time the user picked is kept.
 */
export const resolveSampleTime = (value: Date, pickedByUser: boolean): Date =>
	pickedByUser ? value : currentSampleMinute();
